<template>
    <div v-if="loader">
        <Loading />
    </div>
    <div class="p-5" v-else>
        <ContentComponent :nombreAlerta="$route.params.nombre">
            <template #principal>
                <p class="subtitulos text-center">{{ $route.params.nombre }}</p>    
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Bloque</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="bloque, index in bloques" :key="index">
                                <td>
                                    <router-link :to="'/unidades/' + bloque.sede.nombre + '/' + bloque.bloque_edificio + '/' + bloque.id">{{ bloque.bloque_edificio }}</router-link>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </ContentComponent> 
    </div>
</template>
<script>
    import axios from 'axios';
    import Loading from '@/components/Loader/Loading.vue';
    import ContentComponent from '@/components/Content/Index.vue';
    export default {
        components: {
            ContentComponent, Loading
        },
        data(){
            return{
                bloques: [],
                loader: true
            }
        },
        mounted() {
            this.getBloques()
        },
        methods: {
            getBloques(){
                axios.get(`/api/bloques/${this.$route.params.id}`, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    console.log(res.data)
                    this.bloques = res.data.bloques;
                    this.$store.state.sede = '-' + res.data.bloques[0].sede.nombre;
                    this.loader = false;
                })
                .catch(err => {
                    this.loader = false;
                    console.log(err)
                })
            }
        },
    }
</script>